<template>
  <v-container pa-0 fluid>
    <v-card outlined>
      <v-row v-if="debug">
        <v-col>
          <code>{{ servicesList }}--{{ windowHeight }}</code>
        </v-col>
      </v-row>

      <v-data-table
        :headers="filteredHeaders"
        :items="items"
        :items-per-page-options="[10, 25, 50, 100]"
        :items-per-page="-1"
        item-key="id"
        :search="search"
        class="edit-table"
        fixed-header
        :height="gridHeight"
        v-model="selectedRows"
        show-select
        sort-by="dateFrom"
        sort-desc
      >
        <template v-slot:item.agentGroup="{ item }">
          {{ item.agentGroup ? item.agentGroup.name : "All Groups" }}
        </template>
        <template v-slot:item.service.name="{ item }">
          <v-edit-dialog large persistent @save="onUpdateService(item)">
            <span>{{ item.service.name }}</span>
            <template v-slot:input>
              <div class="mt-4 text-h6">Update Service</div>
              <v-select
                :items="servicesList"
                item-value="id"
                item-text="name"
                v-model="item.service.id"
              ></v-select>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:item.dateFrom="{ item }">
          <span>{{ item.dateFrom | formatDate }} </span>
        </template>
        <template v-slot:item.dateTo="{ item }">
          <span>{{ item.dateTo | formatDate }} </span>
        </template>
        <template v-slot:item.api="{ item }">
          <v-simple-checkbox
            v-model="item.api"
            primary
            hide-details
            :disabled="true"
            class="ma-0"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.marketPlace="{ item }">
          <v-simple-checkbox
            v-model="item.marketPlace"
            primary
            hide-details
            :disabled="true"
            class="ma-0"
          ></v-simple-checkbox>
        </template>
        <template v-slot:item.exception="{ item }">
          <v-simple-checkbox
            v-model="item.exception"
            primary
            hide-details
            :disabled="true"
            class="ma-0"
          ></v-simple-checkbox
        ></template>
        <template
          v-for="field in editableNumberFields"
          v-slot:[`item.${field.name}`]="{ item }"
        >
          <v-edit-dialog
            :return-value.sync="item[field.name]"
            large
            persistent
            @save="onRowUpdate(field.name, item)"
            :key="field.name"
          >
            <span v-if="!intFields.includes(field.name)">{{
              parseFloat(item[field.name]).toFixed(2) | priceLabeler
            }}</span>
            <span v-else>{{ item[field.name] }}</span>
            <template v-slot:input>
              <div class="mt-4 text-h6">Update Cost</div>
              <v-text-field
                v-model.number="item[field.name]"
                label="Edit"
                single-line
                autofocus
                type="number"
              ></v-text-field>
            </template>
          </v-edit-dialog>
        </template>
        <template v-slot:item.actions="{ item }">
          <default-list-actions
            :item="item"
            :hide-view="true"
            item-name="supplier rate"
            @editItem="$emit('editItem', $event)"
            @deleteItem="$emit('deleteItem', $event)"
            :hide-remove="
              $store.getters.hasAccessTo('suppliers:view_only') ||
              !$store.getters.hasAccessTo('suppliers:delete')
            "
            :hide-edit="$store.getters.hasAccessTo('suppliers:view_only')"
          >
            <template
              slot="extraButton"
              v-if="!$store.getters.hasAccessTo('suppliers:view_only')"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    small
                    class="mx-0"
                    @click="copyItem(item)"
                  >
                    <v-icon color="#ef6c00" small>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copy</span>
              </v-tooltip>
            </template>
          </default-list-actions>
        </template>
        <template v-slot:footer>
          <v-speed-dial
            v-show="selectedRows.length > 0"
            open-on-hover
            absolute
            direction="right"
            v-model="listFab"
          >
            <template v-slot:activator>
              <v-btn v-model="listFab" color="blue darken-2" dark fab>
                <v-icon v-if="listFab">mdi-close</v-icon>
                <v-icon v-else>mdi-menu</v-icon>
              </v-btn>
            </template>
            <v-btn
              fab
              dark
              small
              color="indigo"
              @click="onShowBatchUpdate"
              v-if="$store.getters.hasAccessTo('suppliers:edit')"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-pencil</v-icon>
                </template>
                <span>Batch Update</span>
              </v-tooltip>
            </v-btn>
            <v-btn fab dark small color="green" @click="onExport">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-database-export</v-icon>
                </template>
                Export Selected Records
              </v-tooltip>
            </v-btn>
            <v-btn fab dark small color="primary" @click="onExportAll">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-all-inclusive</v-icon>
                </template>
                Export All Records
              </v-tooltip>
            </v-btn>
            <v-btn
              fab
              dark
              small
              color="red"
              @click="onDeleteRecords"
              v-if="!hideDelete"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-delete</v-icon>
                </template>
                Remove Selected Records
              </v-tooltip>
            </v-btn>
          </v-speed-dial>
        </template>

        <template v-if="false" v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td v-if="showColumn('dateFrom')" class="text-xs-left">
                <date-picker
                  v-if="editableItem == item.id"
                  custom-label="Date From"
                  :gt-date-string="item.dateFrom"
                  :range-start="dateFromRangeStart"
                  :range-end="item.dateTo"
                  @onDateSelected="
                    saveItem(Object.assign({}, item, { dateFrom: $event }))
                  "
                  :outlined="outlinedInputs"
                ></date-picker>
                <span v-else>{{ item.dateFrom | formatDate }}</span>
              </td>
              <td v-if="showColumn('dateTo')" class="text-xs-left">
                <date-picker
                  v-if="editableItem == item.id"
                  custom-label="Date To"
                  :range-start="item.dateFrom"
                  :range-end="dateToRangeEnd(item.dateFrom)"
                  :gtDateString="item.dateTo"
                  @onDateSelected="
                    saveItem(Object.assign({}, item, { dateTo: $event }))
                  "
                  :outlined="outlinedInputs"
                ></date-picker>
                <span v-else>{{ item.dateTo | formatDate }}</span>
              </td>
              <td v-if="showColumn('service')" class="text-xs-left">
                <v-select
                  :outlined="outlinedInputs"
                  item-value="node.id"
                  item-text="node.name"
                  v-model="item.serviceId"
                  v-if="editableItem == item.id"
                  :items="services"
                  @change="saveItem(item)"
                ></v-select>
                <span v-else>{{ item.service.name }}</span>
              </td>
              <td v-if="showColumn('code')" class="text-xs-left">
                <span>{{ item.service.code }}</span>
              </td>
              <td v-if="showColumn('rateTypeCode')" class="text-xs-left">
                <v-select
                  v-if="editableItem == item.id"
                  :items="rateTypes"
                  :value="item.rateTypeCode"
                  label="Rate Type"
                  item-text="name"
                  item-value="code"
                  @change="
                    saveItem(Object.assign({}, item, { rateTypeCode: $event }))
                  "
                  :outlined="outlinedInputs"
                >
                  <template slot="selection" slot-scope="data">
                    {{ data.item.code }}
                  </template>
                </v-select>
                <span v-else>{{ item.rateTypeCode }}</span>
              </td>
              <td v-if="showColumn('agentGroup')" class="text-xs-left">
                <v-select
                  v-if="editableItem == item.id"
                  :items="agentGroups"
                  :value="item.groupId"
                  label="Agent Group"
                  item-text="name"
                  item-value="id"
                  @change="
                    saveItem(Object.assign({}, item, { groupId: $event }))
                  "
                  :outlined="outlinedInputs"
                ></v-select>
                <span v-else>
                  {{ item.agentGroup ? item.agentGroup.name : "" }}
                </span>
              </td>
              <td v-if="showColumn('ratePlan')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Rate Plan"
                  :value="item.ratePlan"
                  @change="
                    saveItem(Object.assign({}, item, { ratePlan: $event }))
                  "
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{ item.ratePlan }}</span>
              </td>
              <td v-if="showColumn('businessModel')" class="text-xs-left">
                {{ item.businessModel }}
              </td>
              <td v-if="showColumn('supplierCommission')" class="text-xs-left">
                {{ item.supplierCommission }}
              </td>
              <td v-if="showColumn('adultBuy1')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Cost"
                  type="number"
                  min="0"
                  v-model="item.adultBuy1"
                  @change="onPriceChange(item)('adultBuy')"
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{
                  parseFloat(item.adultBuy1).toFixed(2) | priceLabeler
                }}</span>
              </td>
              <td v-if="showColumn('adultSell1')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Sell"
                  v-model="item.adultSell1"
                  @change="onPriceChange(item)('adultSell')"
                  type="number"
                  min="0"
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{
                  Number(parseFloat(item.adultSell1).toFixed(2)).toLocaleString(
                    undefined,
                    {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }
                  )
                }}</span>
              </td>
              <td v-if="showColumn('childBuy1')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Cost"
                  type="number"
                  min="0"
                  v-model="item.childBuy1"
                  @change="onPriceChange(item)('childBuy')"
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{
                  parseFloat(item.childBuy1).toFixed(2) | priceLabeler
                }}</span>
              </td>
              <td v-if="showColumn('childSell1')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Sell"
                  v-model="item.childSell1"
                  @change="onPriceChange(item)('childSell')"
                  type="number"
                  min="0"
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{
                  parseFloat(item.childSell1).toFixed(2) | priceLabeler
                }}</span>
              </td>
              <td v-if="showColumn('infantBuy1')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Cost"
                  type="number"
                  min="0"
                  v-model="item.infantBuy1"
                  @change="onPriceChange(item)('infantBuy')"
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{
                  parseFloat(item.infantBuy1).toFixed(2) | priceLabeler
                }}</span>
              </td>
              <td v-if="showColumn('infantSell1')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Sell"
                  v-model="item.infantSell1"
                  @change="onPriceChange(item)('infantSell')"
                  type="number"
                  min="0"
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{
                  parseFloat(item.infantSell1).toFixed(2) | priceLabeler
                }}</span>
              </td>
              <td v-if="showColumn('currencyCode')" class="text-xs-left">
                <currency-list-select
                  v-if="editableItem == item.id"
                  custom-label="Currency"
                  v-model="item.currencyCode"
                  :showCodeAsName="true"
                  @input="
                    saveItem(Object.assign({}, item, { currencyCode: $event }))
                  "
                  :outlined="outlinedInputs"
                ></currency-list-select>
                <span v-else>{{ item.currencyCode }}</span>
              </td>
              <td v-if="showColumn('markup')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Markup"
                  :value="item.markup"
                  type="number"
                  @change="
                    saveItem(
                      Object.assign({}, item, { markup: parseFloat($event) })
                    )
                  "
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{ item.markup }}</span>
              </td>
              <td v-if="showColumn('marketPlace')" class="text-xs-left">
                <v-checkbox
                  v-model="item.marketPlace"
                  primary
                  hide-details
                  :disabled="true"
                  class="ma-0"
                ></v-checkbox>
              </td>
              <td v-if="showColumn('api')" class="text-xs-left">
                <v-checkbox
                  v-model="item.api"
                  primary
                  hide-details
                  :disabled="true"
                  class="ma-0"
                ></v-checkbox>
              </td>
              <td v-if="showColumn('minStay')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Min Stay"
                  :value="item.minStay"
                  type="number"
                  @change="
                    saveItem(
                      Object.assign({}, item, { minStay: parseInt($event) })
                    )
                  "
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{ item.minStay }}</span>
              </td>
              <td v-if="showColumn('maxStay')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Max Stay"
                  :value="item.maxStay"
                  type="number"
                  @change="
                    saveItem(
                      Object.assign({}, item, { maxStay: parseInt($event) })
                    )
                  "
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{ item.maxStay }}</span>
              </td>
              <td v-if="showColumn('minPax')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Min Pax"
                  :value="item.minPax"
                  type="number"
                  @change="
                    saveItem(
                      Object.assign({}, item, { minPax: parseInt($event) })
                    )
                  "
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{ item.minPax }}</span>
              </td>
              <td v-if="showColumn('maxPax')" class="text-xs-left">
                <v-text-field
                  v-if="editableItem == item.id"
                  label="Max Pax"
                  :value="item.maxPax"
                  type="number"
                  @change="
                    saveItem(
                      Object.assign({}, item, { maxPax: parseInt($event) })
                    )
                  "
                  :outlined="outlinedInputs"
                ></v-text-field>
                <span v-else>{{ item.maxPax }}</span>
              </td>
              <td v-if="showColumn('exception')" class="text-xs-center">
                <v-row justify="center">
                  <v-checkbox
                    v-if="editableItem == item.id"
                    v-model="item.exception"
                    class="ma-0"
                    @change="saveItem(item)"
                  ></v-checkbox>
                  <v-checkbox
                    v-else
                    v-model="item.exception"
                    :disabled="true"
                    class="ma-0"
                  ></v-checkbox>
                </v-row>
              </td>
              <td>
                <v-layout row>
                  <default-list-actions
                    :item="item"
                    :hide-view="true"
                    item-name="supplier rate"
                    @editItem="$emit('editItem', $event)"
                    @deleteItem="$emit('deleteItem', $event)"
                    :hide-remove="
                      $store.getters.hasAccessTo('suppliers:view_only')
                    "
                    :hide-edit="
                      $store.getters.hasAccessTo('suppliers:view_only')
                    "
                  >
                    <template
                      slot="extraButton"
                      v-if="!$store.getters.hasAccessTo('suppliers:view_only')"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            v-on="on"
                            icon
                            small
                            class="mx-0"
                            @click="copyItem(item)"
                          >
                            <v-icon color="#ef6c00" small
                              >mdi-content-copy</v-icon
                            >
                          </v-btn>
                        </template>
                        <span>Copy</span>
                      </v-tooltip>
                    </template>
                  </default-list-actions>
                </v-layout>
              </td>
            </tr>
          </tbody>
        </template></v-data-table
      ></v-card
    >
    <batch-update-dialog
      :show="showBatchUpdateDialog"
      :columns="editableColumns"
      @close="showBatchUpdateDialog = false"
      @update="onUpdateRecords"
    />
  </v-container>
</template>
<script>
import CurrencyListSelect from "../../../shared/CurrencyListSelect";
import DatePicker from "../../../shared/DatePicker";
import {
  SERVICE_PRICE_UPDATE_MUTATION,
  SUPPLIER_PRICES_CREATE_MUTATION,
  UPDATE_RECORDS_MUTATION,
} from "../../../../../constants/graphql";
import DefaultListActions from "../../../shared/DefaultListActions";
import EventBus from "../../../../../store/event-bus";
import BatchUpdateDialog from "../../../shared/BatchUpdateDialog.vue";
import ListExport from "../../../shared/list-actions/ListExport.vue";

const moment = require("moment");

export default {
  name: "SupplierRatesEditListTableView",

  components: {
    CurrencyListSelect,
    DatePicker,
    DefaultListActions,
    BatchUpdateDialog,
    ListExport,
  },

  props: {
    supplierRatesList: {
      type: Array,
      default: () => [],
    },
    rateTypes: {
      type: Array,
      default: () => {},
    },
    agentGroups: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
      default: () => [],
    },
    visibleColumns: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    services: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      debug: false,
      editableItem: "",
      fixedHeader: true,
      windowHeight: window.innerHeight,
      listFab: true,
      selectedRows: [],
      showBatchUpdateDialog: false,
    };
  },

  computed: {
    servicesList() {
      return this.services.map((service) => ({
        id: service.node.id,
        name: service.node.name,
      }));
    },
    editableColumns() {
      return [
        /* {
          name: "rate_plan",
          type: "STRING",
          label: "Rate Plan",
        },
        {
          name: "markup",
          type: "NUMBER",
          label: "Markup",
        },
        {
          name: "supplier_commission",
          type: "NUMBER",
          label: "Supplier Commission",
        },*/
        {
          name: "date_from",
          type: "DATE",
          label: "Valid From",
        },
        {
          name: "date_to",
          type: "DATE",
          label: "Valid To",
        },
        {
          name: "api",
          type: "BOOLEAN",
          label: "API",
        },
        {
          name: "market_place",
          type: "BOOLEAN",
          label: "Market Place",
        },
        {
          name: "is_exception",
          type: "BOOLEAN",
          label: "Exception",
        },
      ];
    },
    intFields() {
      return ["minStay", "maxStay", "minPax", "maxPax"];
    },
    editableNumberFields() {
      const fields = [
        "adultBuy1",
        "adultSell1",
        "childBuy1",
        "childSell1",
        "infantBuy1",
        "infantSell1",
        "markup",
        "minStay",
        "maxStay",
        "minPax",
        "maxPax",
      ];
      return this.headers.filter((h) => fields.includes(h.name));
    },
    gridHeight() {
      if (!this.fixedHeader) {
        return null;
      }
      return this.items && this.items.length >= 20
        ? this.windowHeight - 500
        : null;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      return this.supplierRatesList && this.supplierRatesList.length > 0
        ? this.supplierRatesList.map((item) => ({
            ...item,
            serviceId: item.service.id,
            service: { ...item.service },
          }))
        : [];
    },
    filteredHeaders() {
      return this.headers.filter(
        (h) => this.visibleColumns.indexOf(h.name) > -1
      );
    },
    dateFromRangeStart() {
      return moment().subtract(5, "years").toISOString(true);
    },
    hideDelete() {
      return (
        this.$store.getters.hasAccessTo("suppliers:view_only") ||
        !this.$store.getters.hasAccessTo("suppliers:delete")
      );
    },
  },

  methods: {
    onExport() {
      this.$emit("export", this.selectedRows);
    },
    onExportAll() {
      this.$emit("export-all", this.selectedRows);
    },

    onShowBatchUpdate() {
      this.showBatchUpdateDialog = true;
    },
    onRowUpdate(field, item) {
      //console.log(field, item);
      //update sell prices
      if (field.includes("Buy")) {
        const sellField = field.replace("Buy", "Sell");
        item[sellField] = item[field] + (item[field] * item.markup) / 100;
        //update all sell prices
        for (let i = 1; i <= 7; i++) {
          const buyPriceField = `${field.slice(0, -1)}${i}`;
          const selPriceField = `${sellField.slice(0, -1)}${i}`;
          item[buyPriceField] = item[field];
          item[selPriceField] = item[sellField];
        }
      } else if (field.includes("Sell")) {
        //update all sell prices
        for (let i = 1; i <= 7; i++) {
          const priceField = `${field.slice(0, -1)}${i}`;
          item[priceField] = item[field];
        }
      }
      //update other price fields

      this.saveItem(item);
    },
    onDeleteRecords() {
      //console.log("emitting deleteRecords", this.selectedRows);
      this.$emit("deleteRecords", this.selectedRows);
    },

    onUpdateService(item) {
      //console.log(item.serviceId, item.service.id);
      item.serviceId = item.service.id;
      this.saveItem(item);
    },
    showColumn(fieldName) {
      return this.visibleColumns.find((name) => name === fieldName);
    },
    saveItem(editedItem) {
      const { __typename, ...vars } = editedItem;
      delete vars.service;
      //vars.serviceId = editedItem.service.id;
      //console.log(editedItem);
      this.$apollo
        .mutate({
          mutation: SERVICE_PRICE_UPDATE_MUTATION,
          variables: {
            ...vars,
          },
        })
        .then((data) => {
          this.onSave();
        });
    },
    dateToRangeEnd(date) {
      return moment(date).add(10, "years").toISOString(true);
    },
    copyItem(item) {
      item = { ...item };

      const { __typename, agentGroup, service, id, ...vars } = item;

      vars.serviceId = item.service.id;

      this.$apollo
        .mutate({
          mutation: SUPPLIER_PRICES_CREATE_MUTATION,
          variables: {
            prices: [vars],
          },
        })
        .then((data) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Rate Copied",
          });

          EventBus.$emit("refetch-supplier-rates");
        });
    },
    onSave() {
      this.$store.dispatch("showAppSnackbar", { msg: "Supplier Rate saved." });
      this.editableItem = null;
      EventBus.$emit("refetch-supplier-rates");
    },
    onPriceChange(item) {
      return (field) => {
        for (let i = 1; i <= 7; i++) {
          item[`${field}${i}`] = Number(item[`${field}1`]);
        }
        this.saveItem(item);
      };
    },
    onUpdateRecords(fields) {
      // this.selectedRows.forEach((item) => {
      //   fields.forEach((field) => {
      //     item[field.name] = field.value;
      //   });
      //   this.saveItem(item);
      // });
      const records = this.selectedRows.map((item) => item.id);
      const attributes = fields.map((field) => {
        return {
          name: field.name,
          value: field.value.toString(),
        };
      });
      this.$apollo
        .mutate({
          mutation: UPDATE_RECORDS_MUTATION,
          variables: {
            input: {
              records,
              attributes,
              model: "Price",
            },
          },
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Records Updated.",
          });
          this.showBatchUpdateDialog = false;
          EventBus.$emit("refetch-supplier-rates");
        });
    },
  },

  mounted() {
    window.addEventListener("resize", () => {
      this.windowHeight = window.innerHeight;
    });
  },
};
</script>

<style scoped>
.v-data-table td {
  vertical-align: middle !important;
  min-height: 76px;
  padding-top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/supplier-rates/edit/SupplierRatesEditListTableView.vue